/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusIndividuelleAnforderungWriteResultDto } from '../../models/lexplus-individuelle-anforderung-write-result-dto';
import { LexplusUpdateIndividuelleAnforderungDto } from '../../models/lexplus-update-individuelle-anforderung-dto';

export interface IndividuelleAnforderungWriteControllerUpdateIndividuelleAnforderungV1$Params {
  individuelleAnforderungID: string;
      body: LexplusUpdateIndividuelleAnforderungDto
}

export function individuelleAnforderungWriteControllerUpdateIndividuelleAnforderungV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungWriteControllerUpdateIndividuelleAnforderungV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusIndividuelleAnforderungWriteResultDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungWriteControllerUpdateIndividuelleAnforderungV1.PATH, 'patch');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusIndividuelleAnforderungWriteResultDto>;
    })
  );
}

individuelleAnforderungWriteControllerUpdateIndividuelleAnforderungV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}';
